/** Enforcing theme tokens to be used for cupra */
const themeTokens = {
    primaryColor: '#000000',
    hoveredPrimaryColor: '#0d0d0d',
    textColor: '#fff',

    baseFontSize: '1rem',
    buttonFontSize: '1rem',
    inputFontSize: '1rem',

    inputFieldHeight: '34px',
};

export default themeTokens;
